import { FetchConversationsParams, FetchUsersParams } from './conversationsSlice'
import { getAfterCursor, parameterizeArrayofObjects } from '../../../../../utils/graphqlUtil'
import { gql } from 'graphql-request'

const getConversationQueryString = (params: FetchConversationsParams) => {
  const { datasourceId, filter, booleanFilter, page, pageSize } = params

  let paramString = ''
  const filterString = filter ? parameterizeArrayofObjects(filter) : ''
  const booleanFilterString = booleanFilter ? parameterizeArrayofObjects(booleanFilter) : ''
  if (filterString) {
    paramString += `, filter: ${filterString}`
  }
  if (booleanFilterString) {
    paramString += `, booleanFilter: ${booleanFilterString}`
  }

  const cursor = getAfterCursor(page || 1, pageSize)
  const pageParams = page === undefined ? '' : `first: ${pageSize}, after: "${cursor}",`

  return `datasourceIds: "${datasourceId}", ${pageParams} ${paramString}`
}

export const queryCopilotConversations = (params: FetchConversationsParams) => {
  return gql`
    {
    conversation(${getConversationQueryString(params)}) {
        edges {
          node {
            id
            conversationId
            name
            piiDocumentsCount
            appType
            attachmentsCount
            postTime
            datasourceUser {
              count
              edges {
                node {
                  name
                }
              }
            }
            objects(category: FILE) {
              count
              edges {
                node {
                  name
                  type
                }
              }
            }
            attributes {
              count
              edges {
                node {
                  name
                }
              }
            }
            userEntities {
              count
              edges {
                node {
                  name
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryCopilotConversations = (raw: any) => {
  return {
    list:
      raw.conversation?.edges?.map(({ node }) => ({
        id: node?.id || '',
        conversationId: node?.conversationId || '',
        name: node?.name || '',
        documentsCount: node?.piiDocumentsCount || 0,
        appType: node?.appType,
        attachmentsCount: node?.attachmentsCount || 0,
        user: node?.datasourceUser?.edges[0]?.node?.name,
        filesCount: node?.objects?.count || 0,
        attachments: node?.objects.edges.map(({ node }) => ({
          name: node?.name,
          type: node?.type
        })),
        attributesCount: node?.attributes?.count || 0,
        attributes: node?.attributes.edges.map(({ node }) => node?.name),
        entitiesCount: node?.userEntities?.count,
        entities: node?.userEntities.edges.map(({ node }) => node?.name),
        postTime: node?.postTime
      })) || []
  }
}

export const queryCopilotConversationsCount = (params: FetchConversationsParams) => {
  return gql`
    {
      conversation(${getConversationQueryString(params)}) {
        count
      }
    }
  `
}

export const mapQueryCopilotConversationsCount = (raw: any) => {
  return {
    totalList: raw.conversation?.count || 0
  }
}

export const queryCopilotUsers = (params: FetchUsersParams) => {
  const { filter, booleanFilter } = params

  let paramString = ''
  const filterString = filter ? parameterizeArrayofObjects(filter) : ''
  const booleanFilterString = booleanFilter ? parameterizeArrayofObjects(booleanFilter) : ''
  if (filterString) {
    paramString += `, filter: ${filterString}`
  }
  if (booleanFilterString) {
    paramString += `, booleanFilter: ${booleanFilterString}`
  }

  return gql`
    {
      datasourceUser(${paramString}) {
        count
        edges {
          node {
            userId
            name
            piiConversationsCount
            piiDataFilesCount
            attributes {
              count
            }
            userEntities {
              count
            }
          }
        }
      }
    }
  `
}

export const mapQueryCopilotUsers = (raw: any) => {
  return {
    list:
      raw.datasourceUser?.edges?.map(({ node }) => ({
        id: node.userId,
        name: node.name,
        conversationsCount: node?.piiConversationsCount || 0,
        filesCount: node?.piiDataFilesCount || 0,
        attributesCount: node.attributes?.count,
        entitiesCount: node.userEntities?.count
      })) || [],
    totalList: raw.datasourceUser?.count || 0
  }
}

export const queryCopilotAllUsers = (params: FetchUsersParams) => {
  const { filter, booleanFilter } = params

  let paramString = ''
  const filterString = filter ? parameterizeArrayofObjects(filter) : ''
  const booleanFilterString = booleanFilter ? parameterizeArrayofObjects(booleanFilter) : ''
  if (filterString) {
    paramString += `, filter: ${filterString}`
  }
  if (booleanFilterString) {
    paramString += `, booleanFilter: ${booleanFilterString}`
  }

  return gql`
    {
      datasourceUser(${paramString}) {
        edges {
          node {
            id: userId
            name
          }
        }
      }
    }
  `
}

export const mapQueryCopilotAllUsers = (raw: any) => {
  return raw.datasourceUser?.edges?.map(({ node }) => ({ id: node?.id, name: node?.name }))
}
